var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 5,
    viewBox: "0 0 15 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1768 2.67678C14.2744 2.57915 14.2744 2.42085 14.1768 2.32322L12.5858 0.732233C12.4882 0.634602 12.3299 0.634602 12.2322 0.732233C12.1346 0.829864 12.1346 0.988155 12.2322 1.08579L13.6464 2.5L12.2322 3.91421C12.1346 4.01184 12.1346 4.17014 12.2322 4.26777C12.3299 4.3654 12.4882 4.3654 12.5858 4.26777L14.1768 2.67678ZM0.5 2.75H14V2.25H0.5V2.75Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconRed);
export default __webpack_public_path__ + "static/media/arrow-icon-red.832f7075da6a2c50f7efe91802612dd2.svg";
export { ForwardRef as ReactComponent };